import { capitalizeFirstLetterOfEachWord } from '@dxb-web-ui-framework/common/utils/String';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { RoutingTransferTypes } from '../domain/Transfer/entities/RoutingResponseDTO';
import { transactionUILabelValuesEnabler } from '.';

const transformDataToAutocompleteOptions = (data?: (string | undefined)[]) =>
  data?.map((dataString, index) => ({
    id: index,
    value: dataString,
    label: capitalizeFirstLetterOfEachWord(dataString ?? ''),
    checked: false,
  }));

const calculateExchangeRate = (
  debitCurrency: string,
  creditCurrency: string,
  rateCurrency: string,
  rateAmount: number,
) => {
  const firstAmount = 1.0;
  if (debitCurrency === 'EUR' || creditCurrency === 'EUR') {
    return debitCurrency === 'EUR'
      ? { firstCurrency: debitCurrency, firstAmount, secondCurrency: creditCurrency, secondAmount: rateAmount }
      : { firstCurrency: creditCurrency, firstAmount, secondCurrency: debitCurrency, secondAmount: rateAmount };
  } else {
    return debitCurrency === rateCurrency
      ? { firstCurrency: rateCurrency, firstAmount, secondCurrency: creditCurrency, secondAmount: rateAmount }
      : { firstCurrency: rateCurrency, firstAmount, secondCurrency: debitCurrency, secondAmount: rateAmount };
  }
};

const shouldShowRequestRateBtn = ({
  transferType,
  debitCurrency,
  orderCurrency,
  isDebitCurrencySameWithOrderCurrency,
  isLastAuthorizer,
  isEligibleForDealerRate,
}: {
  transferType: Nullable<RoutingTransferTypes>;
  debitCurrency?: number | string;
  orderCurrency?: number | string;
  isDebitCurrencySameWithOrderCurrency?: boolean;
  isLastAuthorizer?: boolean;
  isEligibleForDealerRate?: boolean;
}): boolean => {
  const { shouldShowExchangeRates } = transactionUILabelValuesEnabler(transferType);
  if (
    transferType === RoutingTransferTypes.CORPORATE_INTERNAL_OTHER_CURRENCY ||
    transferType === RoutingTransferTypes.INTRABANK_OTHER_CURRENCY
  ) {
    return !!(
      isEligibleForDealerRate &&
      isLastAuthorizer &&
      !(isDebitCurrencySameWithOrderCurrency ?? debitCurrency === orderCurrency)
    );
  } else {
    return !!(isEligibleForDealerRate && isLastAuthorizer && shouldShowExchangeRates);
  }
};

export { transformDataToAutocompleteOptions, calculateExchangeRate, shouldShowRequestRateBtn };
